import {CustomScheduleComponent} from "./CustomScheduleComponent";
import {EmployeeSchedule} from "../../../model/schedule.model";
import {DayType} from "../../../model/common.model";

export class CustomScheduleComponentManager<T extends CustomScheduleComponent> {


  // protected workShiftByAnotherKey = new Map<string, T[]>();
  protected workShiftBySomeKey = new Map<string, T[]>();
  protected allComponents = new Array<T>();

  public add( bean: T) {
    this._addWithKey(bean.model.jobUnitKey,bean);
    // if (!this.workShiftBySomeKey.get(bean.model.jobUnitKey)) {
    //   // console.log('Creating array for key: ' + bean.model.jobUnitKey);
    //   this.workShiftBySomeKey.set(bean.model.jobUnitKey, new Array<T>());
    // }
    //
    // // console.log('Adding key to array >' + bean.model.key + '<');
    // this.workShiftBySomeKey.get(bean.model.jobUnitKey).push(bean);
    // this.allComponents.push(bean);
    //
    // bean._manager = this;
  }
  public addWithKey( key: string, bean: T) {
    this._addWithKey(bean.model.jobUnitKey+'.'+key,bean);
  }

  protected _addWithKey( key: string, bean: T) {

    if (!this.workShiftBySomeKey.get(key)) {
      // console.log('Creating array for key: ' + bean.model.jobUnitKey);
      this.workShiftBySomeKey.set(key, new Array<T>());
    }

    // console.log('Adding key to array >' + bean.model.key + '<');
    this.workShiftBySomeKey.get(key).push(bean);
    this.allComponents.push(bean);

    bean._manager = this;
  }


  public get(jobUnitkey: string): T[] {
    // console.log('getting >' + jobUnitkey + '<');
    const res = this.workShiftBySomeKey.get(jobUnitkey);
    if (!res) {
      // console.log('returning empty array');
      return new Array<T>();
    }
    return res;
  }

  get jobUnitKeys(): string[] {
    return Array.from(this.workShiftBySomeKey.keys());
  }

  public get components(): T[] {
    return this.allComponents;
  }

  public clear() {
    this.workShiftBySomeKey.clear();
    this.allComponents = new Array<T>();
  }

  public findSchedulesInConflict(schedule: EmployeeSchedule): EmployeeSchedule[]{
    const res = new Array<EmployeeSchedule>();
    // console.log('Nb Component: ' + this.allComponents.length);
    for (const component of this.allComponents){
      res.push(...component.findSchedulesInConflict(schedule));
    }
    return res;
  }


  public findSchedulesForEmployeeAndDate(employeeId: string, refDt: Date): EmployeeSchedule[]{
    const res = new Array<EmployeeSchedule>();
    for (const component of this.allComponents){
      res.push(...component.findSchedulesForEmployeeAndDate(employeeId,refDt));
    }
    return res;
  }


  /**
   * We don't want an evil Event-Endless-Loop
   */
  public validateErrorsForOtherContainer(calledFrom: T, dt: DayType){
    console.log('nb Components: ' + this.allComponents.length);
    for (const component of this.allComponents){
      if (component.componentId !== calledFrom.componentId){
        if (!component.validateErrorsInCellFor(dt)){
          console.log('Can\'t find other components for '+dt);
        }
        // if (component.getCellComponentPerDayType(dt)){
        //   component.getCellComponentPerDayType(dt).validateForErrors();
        // }else{
        //   console.log('Can\'t find the component for '+dt);
        // }
      }else{
        console.log('Found the caller! ' + calledFrom.componentId);
      }
    }
  }

  public validateErrorsForOtherContainerWithEmployee(calledFrom: T, employeeId: string){
    console.log('nb Components: ' + this.allComponents.length);
    for (const component of this.allComponents){
      if (component.componentId !== calledFrom.componentId){
        if (!component.validateErrorsInCellWithEmployee(employeeId)){
          //console.log('Can\'t find other components for '+employeeId);
        }
        // if (component.getCellComponentPerDayType(dt)){
        //   component.getCellComponentPerDayType(dt).validateForErrors();
        // }else{
        //   console.log('Can\'t find the component for '+dt);
        // }
      }else{
        console.log('Found the caller! ' + calledFrom.componentId);
      }
    }
  }



  public addErrorMessageForSchedulesInConflict(calledFrom: T, schedules: EmployeeSchedule[]):boolean{
    let res = false;
    for (const component of this.allComponents){
      if (component.componentId !== calledFrom.componentId){
        if (component.addErrorMessageForSchedulesInConflict(schedules)){
          res = true;
        // }else{
        //   console.log('Can\'t find the component for ');
        }
      }else{
        console.log('Found the caller! ' + calledFrom.componentId);
      }
    }
    return res;
  }


}
